import React from 'react'
import classes from './DoubleFee.module.css'
const DoubleFees = ({ feePerMonth, totalFees }) => {
  return (
    <div className={classes.container}>
      {/* <div className={classes.box}>
        <p className={classes.title}>Fees per month</p>
        <div className={classes.bottom}>
          <p className={classes.subtitle}>{feePerMonth}</p>
        </div>
      </div>
      <hr className={classes.rule} /> */}
      <div className={classes.box}>
        <p className={classes.title}>Total Fees</p>
        <div className={classes.bottom}>
          <p className={classes.subtitle}>{totalFees}</p>
          {/* <span className={classes.sub}>per year</span> */}
        </div>
      </div>
      <hr />
    </div>
  )
}

export default DoubleFees
